// Fixing a paused schedule from its alert (2026-10-26, Amine on "daily_board_1123 is paused … Narrow window_days": "lets
// fix the fact that we can take an action to fix that kind of cases"). The API takes only existing arguments, each
// keeping its kind; this is how the form reads and writes them.

export type ArgKind = "number" | "boolean" | "text" | "fixed";

/** How an argument is edited: numbers, yes/no and text in the form; anything else (lists, objects, null) stays as is. */
export function kindOf(value: unknown): ArgKind {
  if (typeof value === "number") return "number";
  if (typeof value === "boolean") return "boolean";
  if (typeof value === "string") return "text";
  return "fixed";
}

/** The form's value back in its kind, or undefined when it isn't one (an empty or non-numeric number). */
export function parseArg(kind: ArgKind, raw: string | boolean): unknown {
  if (kind === "boolean") return Boolean(raw);
  if (kind === "number") {
    const s = String(raw).trim();
    if (!s) return undefined;
    const n = Number(s);
    return Number.isFinite(n) ? n : undefined;
  }
  return String(raw);
}

/** Only what changed: what the API is sent. */
export function changedArgs(original: Record<string, unknown>, edited: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(edited).filter(([k, v]) => v !== undefined && k in original && original[k] !== v));
}

/** "window_days 90 → 30" for the notice. */
export function describeChanges(changed: Record<string, [unknown, unknown]>): string {
  return Object.entries(changed).map(([k, [was, now]]) => `${k} ${JSON.stringify(was)} → ${JSON.stringify(now)}`).join(", ");
}
